import { observer } from "mobx-react-lite";
import { Fragment, Key, useState } from "react";
import { ContainerOutlined, FieldTimeOutlined, MessageOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons'
import {
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Table,
  Button,
  Input,
  Space,
  Select,
  DatePicker,
  TimePicker,
  notification
} from "antd";
import { CallManageStore } from '../../../store'
import "./index.css";
import AddPhone from './addPhone'
function RowDetail() {
  const { RangePicker } = DatePicker
  const form = Form.useFormInstance();
  const { Column } = Table;
  const { Option, OptGroup } = Select
  const getFormData = (changeValue: any, allValues: any) => {
    CallManageStore.setLookPower(allValues);
  };
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState({ label: '', value: '' });

  const onChange = (values: any) => {
    setSelectedValues(values);
    // 通过values和options来获取分组名称
    const selectedGroupNames = CallManageStore.numberList.reduce((groupNames: any[], optGroup: { numberRecords: any[]; numberPoolNo: any; }) => {
      const selectedOptions = optGroup.numberRecords.filter((option: { number: any; }) => values.includes(option.number));
      if (selectedOptions.length > 0) {
        groupNames.push(optGroup.numberPoolNo);
      }
      return groupNames;
    }, []);
    CallManageStore.numberPoolNo = selectedGroupNames.join('');
    console.log(CallManageStore.lookPower)
  };
  const onChangeAllbotList = (value: any) => {
    // 通过选中的value找到对应的选项
    const selectedOption = CallManageStore.getAllbotList.find((option: { value: any; }) => option === option);
    setSelectedValue(value);// 设置当前选中值
    CallManageStore.concurrency = selectedOption.concurrency
  };
  const optionsWithDisabled = [
    { label: '周一', value: 'W1' },
    { label: '周二', value: 'W2' },
    { label: '周三', value: 'W3' },
    { label: '周四', value: 'W4' },
    { label: '周五', value: 'W5' },
    { label: '周六', value: 'W6' },
    { label: '周日', value: 'W7' },
  ];
  const checkConcurrencyValue = (rule: any, value: string | undefined, callback: (error?: string) => void) => {
    if (value === undefined || value === '') {
      callback('请输入数字');
    } else if (!/^-?\d+$/.test(value.toString())) {
      callback('请输入整数');
    } else {
      const parsedValue = parseInt(value, 10);
      if (parsedValue < 1 || parsedValue > CallManageStore.concurrency) {
        callback(`输入的数字必须在1到${CallManageStore.concurrency}之间`);
      } else {
        callback();
      }
    }
  };
  const onFinishFailed = (errorInfo: any) => { };
  const onFinish = (values: any) => {
    if (CallManageStore.addOrUpdateModal.update) {
      CallManageStore.submit(CallManageStore.lookPower, 'updata');
    } else {
      CallManageStore.submit(CallManageStore.lookPower, 'add');
    }
  };
  return (
    <Fragment>
      <AddPhone></AddPhone>
      <div className="allContent">
        <div className="formContent">
          <Modal
            width={"900px"}
            centered
            title={CallManageStore.addOrUpdateModal.update ? "编辑" : "新建任务"}
            open={CallManageStore.addOrUpdateModal.isOpen}
            destroyOnClose={true}
            onCancel={() => CallManageStore.addOrUpdateModal.close()}
            footer={null}
          >
            <Form
              form={form}
              labelCol={{ flex: "100px" }}
              name="dynamic_form_complex"
              labelWrap
              initialValues={CallManageStore.lookPower}
              wrapperCol={{ flex: 1 }}
              onValuesChange={getFormData}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row
                style={{ maxHeight: "calc(70vh)", overflow: "auto" }}
              >
                <Col span={23}><Divider orientation="left" style={{ borderColor: '#C0C4CC' }}> <ContainerOutlined /> 基本信息</Divider></Col>
                <Col span={23}><Form.Item
                  label="任务名称"
                  name="taskName"
                  rules={[{ required: true, message: "请输入任务名称" }]}
                >
                  <Input placeholder="请输入任务名称" style={{ width: "330px" }} showCount maxLength={50} disabled={CallManageStore.addOrUpdateModal.update ? true : false} />
                </Form.Item></Col>
                <Col span={23}>
                  <Form.Item
                    label="呼叫话术"
                    name="script"
                    rules={[{ required: true, message: "请输入呼叫话术" }]}
                  >
                    <Select
                      style={{ width: "330px" }}
                      allowClear={true}
                      disabled={CallManageStore.addOrUpdateModal.update ? true : false}
                      placeholder="请选择呼叫话术"
                      onChange={onChangeAllbotList}
                      options={
                        CallManageStore.getAllbotList &&
                        CallManageStore.getAllbotList.map((item: any) => ({
                          value: item.botNameEn,
                          label: item.botName
                        }))
                      }
                    ></Select>
                  </Form.Item>
                </Col>
                <Col span={23}>  <Form.Item
                  label="任务并发"
                  name="concurrency"
                  rules={[
                    { validator: checkConcurrencyValue },
                  ]}
                >
                  {CallManageStore.addOrUpdateModal.update && (
                    <Input
                      disabled={CallManageStore.lookPower.taskStatus == 3 ? false : CallManageStore.lookPower.taskStatus == 6 ? false : CallManageStore.lookPower.taskStatus == 7 ? false : true}
                      min={5} max={CallManageStore.concurrency} placeholder={`请填写1-${CallManageStore.concurrency}的整数`} style={{ width: "330px" }} />
                  )}
                  {CallManageStore.addOrUpdateModal.add && (
                    <Input
                      min={5} max={CallManageStore.concurrency} placeholder={`请填写1-${CallManageStore.concurrency}的整数`} style={{ width: "330px" }} />
                  )}

                </Form.Item></Col>
                <Col span={23}><Divider orientation="left" style={{ borderColor: '#C0C4CC' }}> <MessageOutlined /> 号码配置</Divider></Col>
                <Col span={23}><Form.Item
                  label="主叫号码"
                  name="numberList"
                  rules={[{ required: true, message: "请选择主叫号码" }]}
                >
                  <Select placeholder="请选择" optionLabelProp="label" mode="multiple" onChange={onChange} disabled={CallManageStore.addOrUpdateModal.update ? true : false}>
                    {CallManageStore.numberList.map((item: { numberPoolNo: Key | null | undefined; numberPoolName: any; numberRecords: any[]; }) => (
                      <OptGroup key={item.numberPoolNo} label={item.numberPoolName}>
                        {item.numberRecords.map(option => (
                          <Option key={option.number} value={option.value} disabled={CallManageStore.numberPoolNo != '' && item.numberPoolNo != CallManageStore.numberPoolNo}>
                            {option.number}
                          </Option>
                        ))}
                      </OptGroup>
                    ))}
                  </Select>
                </Form.Item></Col>
                <Col span={23}><Form.Item
                  label="被叫号码"
                  name="phoneList"
                >
                  <Button type="primary" onClick={() => CallManageStore.onAddPhone()}>添加号码</Button>
                  {CallManageStore.AllPhoneCount > 0 && (<span style={{ marginLeft: '10px' }}>累计共成功添加{CallManageStore.AllPhoneCount}条</span>)}
                </Form.Item></Col>
                <Col span={23}><Divider orientation="left" style={{ borderColor: '#C0C4CC' }}> <FieldTimeOutlined /> 时间配置</Divider></Col>
                <Col span={23}> <Form.Item
                  label="任务时间"
                  name="applicationTime"
                  rules={[{ required: true, message: "请输入任务时间" }]}
                >
                  <RangePicker
                    showTime
                    style={{ width: "330px" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder={['开始时间', '结束时间']}
                    disabled={CallManageStore.disTime}
                  />
                </Form.Item></Col>
                <Col span={23}>
                  <Form.Item label="禁拨时间">
                    <Form.List name="forbidTimeList">
                      {(fields, { add, remove }) => (
                        <div>
                          <div>
                            <Button type="link" icon={<PlusOutlined />} onClick={() => add()}>添加禁播时段</Button>
                            <span style={{ color: 'rgb(134, 144, 156)', fontSize: '12px' }}>应政策要求，每日21:00至次日9:00系统均无法拨打</span>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                            {fields.map(({ key, name, ...restField }) => (
                              <Space key={key}>
                                <Form.Item
                                  name={[name, 'week']}
                                  {...restField}
                                  rules={[
                                    { required: true, message: '请选择星期' },
                                  ]}>
                                  <Select
                                    placeholder="请选择"
                                    style={{ width: 150 }}
                                    options={optionsWithDisabled}
                                  />
                                </Form.Item>
                                <Form.Item name={[name, 'time']} {...restField} rules={[{ required: true, message: '请选择时间' }]}>
                                  <TimePicker.RangePicker placeholder={['开始时间', '结束时间']} />
                                </Form.Item>
                                <div style={{ marginTop: -23 }}>
                                  <CloseOutlined
                                    onClick={() => {
                                      remove(name);
                                    }}
                                  />
                                </div>

                              </Space>
                            ))}
                          </div>
                        </div>
                      )}
                    </Form.List>
                  </Form.Item></Col>
                <Col span={23}>
                  <Row>
                    <Col span={24} className="ringAgainTimes-flex">
                      <div style={{ width: '260px' }}>
                        <Form.Item
                          label='未接再呼'
                          name="ringAgainTimes"
                        >
                          <Select style={{ width: "150px", height: '35px' }} placeholder="请选择" size="middle" disabled={CallManageStore.addOrUpdateModal.update && CallManageStore.lookPower.taskStatus != 0 && CallManageStore.disTime[0]}>
                            <Option value={0}>0</Option>
                            <Option value={1}>1</Option>
                            <Option value={2}>2</Option>
                          </Select>
                        </Form.Item>
                      </div>
                      {CallManageStore.lookPower.ringAgainTimes != 0 && (
                        <div style={{ display: 'flex' }}>
                          <Form.Item
                            name="ringAgainInterval"
                            rules={[
                              { required: true, message: '请输入整数!' },
                              { pattern: /^([5-9]|[1-9][0-9]|[1-9][0-9]{2}|1[0-3][0-9]{2}|14[0-3][0-9]|1440)$/, message: '请输入5到1440之间的整数!' },
                            ]}
                          >
                            <Input placeholder="请输入间隔时间" type="number" min={5} max={1440} style={{ width: "150px" }} suffix="min" size="middle" disabled={CallManageStore.addOrUpdateModal.update && CallManageStore.lookPower.taskStatus != 0 && CallManageStore.disTime[0]} />
                          </Form.Item>
                          <span className="hint">请输入5-1440之间的数字</span>
                        </div>
                      )
                      }
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: "12px" }}>
                <Col span={24}>
                  <Form.Item

                    style={{ textAlign: "right" }}
                    wrapperCol={{ span: 18, offset: 6 }}
                  >
                    <Space>
                      <Button
                        htmlType="reset"
                        onClick={() => CallManageStore.addOrUpdateModal.close()}
                      >
                        取消
                      </Button>
                      {/* <Button type="primary" htmlType="submit" onClick={submitPower}>
                        确定
                      </Button> */}
                      <Button type="primary" htmlType="submit">确定</Button>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
      </div>
    </Fragment>
  );
}

export default observer(RowDetail);
